import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59869d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["aria-expanded", "aria-controls"]
const _hoisted_3 = { class: "lp-section__number" }
const _hoisted_4 = { class: "lp-section__info" }
const _hoisted_5 = { class: "lp-section__title" }
const _hoisted_6 = { class: "lp-section__label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "lp-section__dash" }, "—", -1))
const _hoisted_8 = { class: "lp-section__progress" }
const _hoisted_9 = { class: "lp-bar" }
const _hoisted_10 = { class: "lp-section__count" }
const _hoisted_11 = ["id"]

import { computed } from 'vue';
import ResourceRow from './ResourceRow.vue';
import { ISection, sectionProgress, useLearningPathI18n } from './learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    section: null,
    number: null,
    pathwayId: null,
    open: { type: Boolean },
    currentResourceId: null
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  section: ISection
  number: number
  pathwayId: string
  open: boolean
  currentResourceId: number | null
}





const { tl } = useLearningPathI18n();

const progress = computed(() => sectionProgress(props.section));
const percent = computed(() => progress.value.total ? (progress.value.done / progress.value.total) * 100 : 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `lp-section-${__props.section.id}`,
    class: _normalizeClass(["lp-card lp-section", { 'lp-section--open': __props.open }])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "lp-section__header",
      "aria-expanded": __props.open,
      "aria-controls": `lp-section-body-${__props.section.id}`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.number), 1),
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(tl)('section_label')) + " " + _toDisplayString(__props.number), 1),
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(__props.section.title), 1)
        ]),
        _createElementVNode("span", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createElementVNode("span", {
              style: _normalizeStyle({ width: `${_unref(percent)}%` })
            }, null, 4)
          ]),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(tl)('completed_count', { done: _unref(progress).done, total: _unref(progress).total })), 1)
        ])
      ]),
      _createElementVNode("i", {
        class: _normalizeClass(["bi lp-section__chevron", __props.open ? 'bi-chevron-up' : 'bi-chevron-right'])
      }, null, 2)
    ], 8, _hoisted_2),
    (__props.open && __props.section.resources.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `lp-section-body-${__props.section.id}`,
          class: "lp-section__body"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.resources, (resource) => {
            return (_openBlock(), _createBlock(ResourceRow, {
              key: resource.id,
              resource: resource,
              "pathway-id": __props.pathwayId,
              current: resource.id === __props.currentResourceId
            }, null, 8, ["resource", "pathway-id", "current"]))
          }), 128))
        ], 8, _hoisted_11))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})